import { handleResponse, Headers } from '../_helpers';

export const MarkersService = {
  getMarkersByChronicle,
  getMarkersByMap,
  createMarker,
  updateMarker,
  deleteMarker,
  fetchMarkerTypes,
};

function getMarkersByChronicle(chronicleID) {
  const request = {
    method: 'GET',
    headers: Headers.set(),
  };

  return fetch(
    `${process.env.API_URL}/api/v1/markers/chronicle/${chronicleID}`,
    request
  )
    .then(handleResponse)
    .then((markers) => markers);
}

function getMarkersByMap(mapID) {
  const request = {
    method: 'GET',
    headers: Headers.set(),
  };

  return fetch(`${process.env.API_URL}/api/v1/markers/map/${mapID}`, request)
    .then(handleResponse)
    .then((markers) => markers);
}

function createMarker(markerData) {
  const request = {
    method: 'POST',
    headers: Headers.set(),
    body: JSON.stringify(markerData),
  };

  return fetch(`${process.env.API_URL}/api/v1/markers`, request)
    .then(handleResponse)
    .then((marker) => marker);
}

function updateMarker(markerID, markerData) {
  const request = {
    method: 'PUT',
    headers: Headers.set(),
    body: JSON.stringify(markerData),
  };

  return fetch(`${process.env.API_URL}/api/v1/markers/${markerID}`, request)
    .then(handleResponse)
    .then((marker) => marker);
}

function deleteMarker(markerID) {
  const request = {
    method: 'DELETE',
    headers: Headers.set(),
  };

  return fetch(
    `${process.env.API_URL}/api/v1/markers/${markerID}`,
    request
  ).then(handleResponse);
}

function fetchMarkerTypes() {
  const request = {
    method: 'GET',
    headers: Headers.set({ auth: false }),
  };

  return fetch(`${process.env.API_URL}/api/v1/markers/types`, request)
    .then(handleResponse)
    .then((markerTypes) => {
      return markerTypes;
    });
}
